import React, {useMemo} from "react";
import {formatDateMoment, getCurrentDateTime} from "../../../../utils/utils"
import {capitalizeWords} from "../../../../utils/utils"

const QrPrintContentAll = React.forwardRef(({printData, type='inbound' }, ref) => {
  const removeField = ["receipt_photo","sample_photo","upload_report_log_file"];
  const skipSection = ['Data Logger Files']                                            
  const {
    fields, values, printPatientInfo, title="In-Bound Form"
  } = printData || {};
  const search = type == 'inbound' ? "1":"4";
  const topLevel = printData?.printPatientInfo?.patient_information?.print_details?.find((it) => it?.label_type == search)
  const topLogo = topLevel?.brand_logo;
  const brand_name = topLevel?.brand_name;
  const address = topLevel?.org_description || '22WJ+JV7, S Central Rd, MIDC Industrial Area, Shiravane, Nerul, Navi Mumbai, Maharashtra 400705, www.immunoact.com';
  const submittedBy = type == 'inbound' ? printData?.printPatientInfo?.patient_information?.submitted_by: printData?.printPatientInfo?.patient_information?.outbound_submitted_by;
  const submittedAt = type =='inbound' ? printData?.printPatientInfo?.patient_information?.submitted_at: printData?.printPatientInfo?.patient_information?.outbound_submitted_at;
  const submiitedRole = type =='inbound' ?  printData?.printPatientInfo?.patient_information?.submitted_by_role : printData?.printPatientInfo?.patient_information?.outbound_submitted_by_role;
  
  const reviewBy = type == 'inbound' ? printData?.printPatientInfo?.patient_information?.reviewed_by: printData?.printPatientInfo?.patient_information?.outbound_reviewed_by;
  const reviewRole = type =='inbound' ? printData?.printPatientInfo?.patient_information?.reviewed_by_role: printData?.printPatientInfo?.patient_information?.outbound_reviewed_by_role;
  const reviewAt = type =='inbound' ?  printData?.printPatientInfo?.patient_information?.reviewed_at : printData?.printPatientInfo?.patient_information?.outbound_reviewed_at;
 
  const approveBy = type == 'inbound' ? printData?.printPatientInfo?.patient_information?.approved_by: printData?.printPatientInfo?.patient_information?.outbound_approved_by;
  const approveRole = type =='inbound' ? printData?.printPatientInfo?.patient_information?.approved_by_role: printData?.printPatientInfo?.patient_information?.outbound_approved_by_role;
  const approveAt = type =='inbound' ?  printData?.printPatientInfo?.patient_information?.approved_at : printData?.printPatientInfo?.patient_information?.outbound_approved_at;

  const groupedSections = useMemo(() => {
    const sections = [];
    let currentSection = null;
    fields?.forEach((item) => {
      if (item.section) {
        currentSection = {
          title: item.section,
          fields: []
        };
        sections.push(currentSection);
      } else if (currentSection) {
        currentSection.fields.push(item);
      }
    });

    return sections;
  }, [fields]);
  const getCheckboxLabels = (value, options = []) => {
    const valuesArray = Array.isArray(value) ? value : [value];
     return options
        .filter(opt => {
            // Convert both to string for comparison
            const optValueStr = String(opt.value);
            return valuesArray.some(val => 
                String(val) === optValueStr || 
                val === opt.value // Also check direct equality for booleans
            );
        })
        .map(opt => opt.label)
        .join(", ") || "--";
  };

  const formatBagVolume = (data = []) => {
    if (!Array.isArray(data) || data?.length === 0) return "--";

    return data
      .map(item => `Bag ${item?.bag_no} | ${item?.blood_not_used?.length > 0 ? `Not Used`: `Volume ${item?.volume} ml`}`)
      .join(", ");
  };

  const formatValue = (value, field) => {
    if (value === null || value === undefined || value === "") {
      return "--";
    }
    if((field?.type =='radio' || field?.type =='checkbox' || field?.type =='select')){
      if(field?.name == 'alc_declaration' && value?.length > 0){
        return 'True'
      }else{
      return getCheckboxLabels(value, field?.options)
    }
  }
    
    if(["lsm_volumes"]?.includes(field?.name)){
      return formatBagVolume(value)
    }
    
    // Date object
    if (value instanceof Date) {
      return formatDateMoment(value) // 14/12/2025
    }

    // Array
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (item instanceof Date) {
            return formatDateMoment(item);
          }
          if (typeof item === "object") {
            return Object.values(item).join(", ");
          }
          return item;
        })
        .join(" | ");
    }

    // Object
    if (typeof value === "object") {
      return Object.values(value).join(", ");
    }
    
    // Primitive
    return field?.extraContent ? value + ' ' + field?.extraContent : value;
  };

  // Function to organize fields for special 3-field case
  const organizeFields = (fieldsArray) => {
    const validFields = fieldsArray.filter(field => 
      !removeField?.includes(field.name) && 
      !(field?.depend && !values?.[field.name])
    );
    
    // Special case: exactly 3 fields
    if (validFields.length === 3) {
      const [firstField, ...remainingFields] = validFields;
      return [
        { field: firstField, colSpan: 2 }, // First field takes full width
        ...remainingFields.map(field => ({ field, colSpan: 1 })) // Next two take half width each
      ];
    }
    
    // Normal case
    return validFields.map(field => ({ 
      field, 
      colSpan: !field?.label ? 2 : 1 // Fields without labels take full width
    }));
  };

  return (
    <div ref={ref} className="font-sans">
      <div style={{ 
        width: '210mm',
        minHeight: '297mm',
        padding: '15mm',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        fontSize: '10pt',
        backgroundColor: 'white',
        lineHeight: '1.2',
        boxSizing: 'border-box',
        position: "relative"
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#2E5598',
            marginBottom: '5px',
            textAlign: "center",
            display: "flex",
            flexDirection: "column"
          }}>
            <img src={topLogo}  style={{margin:"0 auto", maxWidth:"200px",maxHeight: "100px"}} />
            {brand_name || 'Immunoadoptive Cell Therapy Pvt Ltd'}
          </div>
          <div style={{
            fontSize: '11px',
            color: '#777',
            lineHeight: '1.4'
          }}>
{address}          </div>
          <div style={{
            borderTop: '2px solid #D8D8D8',
            margin: '10px 0',
            width: '100%'
          }}></div>
          
          {/* Form Title */}
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#000',
            margin: '10px 0'
          }}>
            {title}
          </div>
        </div>
        
        <div style={{ paddingBottom: '50px' }}> {/* Add padding to prevent content overlap with footer */}
          {groupedSections?.map((section, sIndex) => {
            if(skipSection?.includes(section.title))
              return null;
              
            // Organize fields for this section
            const organizedFields = organizeFields(section.fields);
            
            return (
              <div key={sIndex}>
                {/* Page break logic */}
                {(section.title === "Physical integrity of transport box and product to be checked" || section.title === "RECEIPT & VERIFICATION (IA Warehouse)") && (
                  <div className="page-break"></div>
                )}
                
                {/* Section title */}
                <div className="section-title">{section.title}</div>
                
                {/* Rounded box */}
                <div className="section-box">
                  <div className="field-grid">
                    {organizedFields.map(({ field, colSpan }, fIndex) => {
                      const hasLabel = Boolean(field?.label);

                      return (
                        <div
                          key={fIndex}
                          className={`field-item ${colSpan === 2 ? "full-width" : ""}`}
                          style={{ gridColumn: `span ${colSpan}` }}
                        >
                          {hasLabel && (
                            <div className="field-label">{field.label}</div>
                          )}
                          <div className={`field-value ${colSpan === 2 ? "full-width-value" : ""}`}>
                            {formatValue(values?.[field.name], field)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
          {/* Date Section - Above the footer */}
        <div className="date-section">
                  <div className="date-row">
                    <div className="date-column">
                      <div className="date-label">Submitted By:</div>
                      <div className="date-name">{capitalizeWords(submittedBy)}{submiitedRole ? '('+submiitedRole+')':''}</div>
                      <div className="date-time">{submittedAt ? getCurrentDateTime(submittedAt):''}</div>
                    </div>
                    
                    <div className="date-column">
                      <div className="date-label">Reviewed By:</div>
                      <div className="date-name">{capitalizeWords(reviewBy)}{reviewRole ? '('+reviewRole+')':''}</div>
                      <div className="date-time">{reviewAt ? getCurrentDateTime(reviewAt):''}</div>
                    </div>
                    
                    <div className="date-column">
                      <div className="date-label">Approved By:</div>
                      <div className="date-name">{capitalizeWords(approveBy)}{approveRole ? '('+approveRole+')':''}</div>
                      <div className="date-time">{approveAt ? getCurrentDateTime(approveAt):''}</div>
                    </div>
                  </div>
                </div>
        </div>
         
        {/* Fixed Footer at bottom of last page */}
        <div className="footer-section">
          <div className="footer-content">
            <div className="declaration-text">
              This document is system generated and does not require a signature.
            </div>
            <div className="confidential-text">
              Confidential document, property of &lsquo;Immunoadoptive Cell Therapy Private Limited&lsquo;, 
              duplication, disclosure and circulation is strictly prohibited
            </div>
          </div>
          <div className="timestamp-section">
            <span className="timestamp-item">
              Printed on: {getCurrentDateTime()}
            </span>
            <span className="timestamp-item">
              Created On: {printPatientInfo?.created_at ? getCurrentDateTime(printPatientInfo?.created_at):''}
            </span>
          </div>
        </div>
        
      </div>
      
      <style>
        {`
          @page {
            size: A4;
            margin: 2mm;
          }
          
          .page-break {
            page-break-before: always;
            break-before: page;
          }
          
          .print-page {
            font-family: Arial, sans-serif;
            font-size: 14px;
            color: #000;
          }
          
          .head-title {
            text-align: center;
            font-weight: bold;
            color: #3571FF;
            font-size: 25px;
          }
          
          .section-title {
            font-size: 14px;
            font-weight: 700;
            padding: 11px 8px 11px;
            letter-spacing: 0.5px;
            background-color: #EAEBEF;
            border-radius: 10px 10px 0 0;
            margin-bottom: 0;
            border: 1px solid #D8D8D8;
            border-bottom: none;
          }
          
          .section-box {
            background: #f8fafc;
            padding: 16px;
            margin-bottom: 15px;
            border: 1px solid #D8D8D8;
            border-top: none;
            border-radius: 0 0 4px 4px;
          }
          
          .field-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 14px 24px;
          }
          
          .field-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          
          .field-item.full-width {
            /* This class is kept for backward compatibility */
          }
          
          .field-label {
            font-weight: 600;
            color: #333;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }
          
          .field-value {
            color: #545454;
            background: #ffffff;
            font-size: 12px;
            min-height: 15px;
            word-break: break-word;
          }
          
          .field-value.full-width-value {
            width: 100%;
          }
          
          /* Footer styles */
          .footer-section {
            position: absolute;
            bottom: 15mm; /* Match the page padding */
            left: 15mm;
            right: 15mm;
            margin-top: auto;
          }
          
          .footer-content {
            text-align: center;
            color: #858585;
            font-size: 10px;
            line-height: 1.4;
            margin-bottom: 5px;
          }
          .date-row {
            display: flex;
            justify-content: space-between;
            gap: 20px;
          }
            .date-label{
            color:#3571FF;
            font-size:10px;
            }
            .date-time{
            color:#A3A3A3;
             font-size:8px;
            }
              .date-name {
            font-size: 11px;
            margin-bottom: 4px;
            color: #545454;
          }
          .declaration-text {
            margin-bottom: 3px;
          }
          
          .confidential-text {
            font-style: italic;
          }
          
          .timestamp-section {
            display: flex;
            justify-content: space-between;
            font-size: 10px;
            color: #858585;
            border-top: 1px solid #e0e0e0;
            padding-top: 5px;
          }
          
          @media print {
            .footer-section {
              position: fixed;
              bottom: 15mm;
              left: 15mm;
              right: 15mm;
            }
            
            .field-value {
              background: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .section-box {
              background: #f8fafc !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .section-title {
              background-color: #EAEBEF !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        `}
      </style>
    </div>
  );
});

export default QrPrintContentAll;